import { ValueOf } from '@builder/utils';

export const IMPORT_DEPENDENCY_TYPES = {
  default: 'default',
  module: 'module',
} as const;

export type ImportDependencyTypes = ValueOf<typeof IMPORT_DEPENDENCY_TYPES>;
